import React, { useState } from 'react';

import { TextField } from '@material-ui/core';
import { getColorFromColorEnumForLevelUp } from 'screens/Levelup/constants';
import styled from 'styled-components';
import { Button } from 'styles/admin';
import {
  Divider1,
  FlexContainer,
  StyledBorderedPaper,
  StyledTextField,
  StyledTooltip,
  VerticallyAlignedFlexContainer,
} from 'styles/common';
import * as yup from 'yup';

import { Typography14 } from 'uiToolkit/Typography';

const CompetencyCheckInCardFooter = ({ onCheckInClickHandler = () => {}, disabled, onCheckInCancelHandler }) => (
  <VerticallyAlignedFlexContainer style={{ marginTop: '1rem' }}>
    <Button
      size="large"
      blueOutline
      style={{
        width: '6rem',
        padding: '0.5rem',
        fontWeight: '600',
        marginRight: '1rem',
        marginLeft: 'auto',
      }}
      onClick={onCheckInCancelHandler}
    >
      Cancel
    </Button>
    <StyledTooltip title={disabled ? 'Please add a comment to check-in' : ''}>
      <span>
        <Button
          size="large"
          blue
          style={{ width: '6rem', padding: '0.5rem', fontWeight: '600' }}
          onClick={onCheckInClickHandler}
          disabled={disabled}
        >
          Check-in
        </Button>
      </span>
    </StyledTooltip>
  </VerticallyAlignedFlexContainer>
);

const remarksValidationSchema = yup
  .string()
  .nullable()
  .transform((v, o) => (o === '' ? null : v))
  .min(1, 'Remarks must be at least 1 character long')
  .required();

const CompetencyCheckInModal = ({
  progress,
  newProgressValue,
  levelUpProgressStatuses = [],
  handleCompetencyProgressStatusChange = () => {},
  hideCheckInModal = () => {},
}) => {
  const fromProgress = levelUpProgressStatuses?.filter(
    ({ progress: levelUpProgress }) => levelUpProgress === progress
  )[0];
  const toProgress = levelUpProgressStatuses?.filter(
    ({ progress: levelUpProgress }) => levelUpProgress === newProgressValue
  )[0];

  const [remarks, setRemarks] = useState('');

  const onCheckInHandler = async () => {
    try {
      if (progress !== newProgressValue) {
        const isValid = await remarksValidationSchema.isValid(remarks);
        if (isValid) {
          handleCompetencyProgressStatusChange({ newProgressValue, comment: remarks });
        }
      } else {
        return false;
      }
    } catch (err) {
      console.error('Error in saving check-in :', err);
    }
  };

  return (
    <Container>
      <FlexContainer style={{ justifyContent: 'space-between', flexDirection: 'column' }}>
        <Typography14 weight={600}>New Check-in</Typography14>
        <VerticallyAlignedFlexContainer>
          <Typography14> Changing from </Typography14>
          <Typography14 color={getColorFromColorEnumForLevelUp(fromProgress?.colour)}>
            &nbsp; "{fromProgress?.displayName}" &nbsp;
          </Typography14>
          <Typography14> to</Typography14>
          <Typography14 color={getColorFromColorEnumForLevelUp(toProgress?.colour)}>
            &nbsp; "{toProgress?.displayName}"
          </Typography14>
        </VerticallyAlignedFlexContainer>
      </FlexContainer>

      <VerticallyAlignedFlexContainer style={{ marginTop: '1.25rem' }}>
        <TextField
          // value={achievedValue}
          variant="outlined"
          // size="small"
          fullWidth
          placeholder="Enter remarks regarding check-in*"
          multiline
          minRows={2}
          maxRows={2}
          rows={2}
          onChange={(e) => {
            setRemarks(e.target.value);
          }}
        />
      </VerticallyAlignedFlexContainer>
      <Divider1 style={{ marginTop: '1rem', marginLeft: '-1rem', marginRight: '-1rem' }} />
      <CompetencyCheckInCardFooter
        onCheckInClickHandler={onCheckInHandler}
        onCheckInCancelHandler={hideCheckInModal}
        disabled={!remarks}
      />
    </Container>
  );
};

const Container = styled(StyledBorderedPaper)`
  width: 25rem;
  padding: 1rem;
  box-shadow: 3px 4px 5px rgba(0, 0, 0, 0.25);
`;

const InputField = styled(StyledTextField)`
  .MuiInputBase-root {
    font-size: ${(props) => props.theme.typography.body2.fontSize};
    height: 2.5rem;
  }
`;

export default CompetencyCheckInModal;
